(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncExpanded = (holder) => {
      const open = holder.hasAttribute('data-oxx-variants-open');
      holder.querySelectorAll('[data-oxx-variants-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', String(open));
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element && event.target.closest('[data-oxx-variants-toggle]');
      const holder = button?.closest('variant-picker')?.parentElement;
      if (!holder) return;
      holder.toggleAttribute('data-oxx-variants-open');
      syncExpanded(holder);
    });

    // Po zmianie wariantu picker przychodzi z serwera z aria-expanded="false".
    document.addEventListener('variant:update', () => {
      requestAnimationFrame(() => {
        document.querySelectorAll('[data-oxx-variants-open]').forEach(syncExpanded);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
